<template>
  <div class="content importList">
    <div class="search-area">
      <div class="w100f t-left mb15"><b>选择需要导入的数据</b></div>
      <div class="import-a-sty">
        <a class="fontC-4fa1a4">考勤及社保公积金导入</a>
      </div>
    </div>
    <div class="search-area mt15">
      <div class="import-sty">
        <el-steps :active="active" align-center>
          <el-step title="上传文件"></el-step>
          <el-step title="确认数据"></el-step>
          <el-step title="导入完成"></el-step>
        </el-steps>
        <div v-if="active == 0">
          <div class="ml71">
            <div class="select-box-item">
              <section class="select-list">
                <div class="search-area-div"><span style="color:red">*</span>账单月份：</div>
                <el-date-picker
                 size="mini"
                  style="width: 250px"
                  value-format="yyyy-MM"
                  v-model="accountMonth"
                  type="month"
                  placeholder="选择月"
                >
                </el-date-picker>
              </section>
              <section class="select-list">
                <div class="search-area-div"><span style="color:red">*</span>核算单元：</div>
                <el-select  size="mini" v-model="unitGuid" placeholder="请选择" style="width: 250px">
                  <el-option v-for="item in bizUnitNameOptions" :key="item.guid" :label="item.label" :value="item.guid">
                  </el-option>
                </el-select>
              </section>
            </div>
            <div class="select-box-item" style="margin-top:20px;">
              <div class="select-list">
                <div class="search-area-div"><el-tooltip class="item" effect="dark" content="若某些药企同一个月同一个人多份账单，则必须选择周期！" placement="top-start">
                    <i class="el-icon-question"></i>
                  </el-tooltip>账单周期：</div>
                <el-select size="mini"  style="width: 250px" v-model="billCycle" placeholder="请选择账单周期">
                  <el-option v-for="(item,index) in billCycleOption" :key="index" :label="item" :value="item"></el-option>
                </el-select>
              </div>
              <div class="select-list">
                <div class="search-area-div"><span style="color:#fff">*</span>周期范围：</div>
                <el-date-picker  size="mini"  style="width: 250px" :format="'MM-dd'" value-format="yyyy-MM-dd"  v-model="cycleDate" type="daterange" range-separator="至"
                  start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
              </div>
            </div>

            <div class="mt15 import-wrap" style="margin-top: 30px">
              下载模板：<el-button plain size="medium" @click="uploadExcel">下载文件模板</el-button>
            </div>
            <div class="mt15 mt15 h120 import-wrap">
              <p class="fl">导入文件：</p>
              <el-upload
                class="upload-demo fl"
                ref="upload"
                action="#"
                :before-upload="beforeUpload"
                multiple
                :limit="1"
                accept=".xlsx,.xsl,.xls,.xlsm"
                :auto-upload="false"
                :on-change="changeFile"
                :on-exceed="handleExceed"
              >
                <el-button size="medium" type="info" v-loading.fullscreen.lock="fullscreenLoading" @click="handelUpload"
                  >点击上传文件</el-button
                >
                <div slot="tip" class="el-upload__tip">
                  当前仅支持 excel 格式文件（大小在5M以内），请使用 Office 2010 及以上版本，否则可能出现乱码<br />
                  必须严格按照模板内容填入数据，否则可能会出现导入异常
                </div>
              </el-upload>
            </div>
          </div>
          <div class="mt15 t-right">
            <el-button size="medium" type="info" @click="next()">下一步</el-button>
          </div>
        </div>
      </div>
      <div v-if="active == 1" class="mt15">
        <div class="summary-sty">
          预计导入<b class="fontC-4fa1a4"> {{ totalRows }} </b>条数据，其中<b class="fontC-4fa1a4"> {{ errorRows }} </b
          >条可能有误，请调整后再导入
          <a class="txt-color-blue ml10" @click="getDataAll()">全部数据 | </a>
          <a class="txt-color-blue" @click="getDataErrorFlagY()">只看错误数据 | </a>
          <a class="txt-color-blue" @click="getDataErrorFlagN()">只看准确数据</a>
          <span style="float: right; padding-right: 10px; color: #4fa1a4; cursor: pointer" @click="pitchDelet"
            >批量删除</span
          >
        </div>
        <el-table
          :data="tableData"
          border
          style="width: 100%"
          v-loading="loading"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column label="序号" width="60" header-align="center" align="center">
            <template slot-scope="scope">
              {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="colA" label="姓名" header-align="center" align="center" width="150">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colA" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colB" label="手机号" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colB" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colC" label="身份证" header-align="center" align="center" width="200">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colC" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colF" label="理论出勤天数" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colF" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colG" label="实际出勤天数" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colG" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colH" label="月行为考核得分" header-align="center" align="center" width="200">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colH" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colI" label="缴纳社保公司承担" header-align="center" align="center" width="200">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colI" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colJ" label="缴纳公积金公司承担" header-align="center" align="center" width="200">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colJ" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colK" label="缴纳社保个人承担" header-align="center" align="center" width="250">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colK" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colL" label="缴纳公积金个人承担" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colL" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colN" label="底薪基数" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colN" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colO" label="绩效基数" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colO" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="errorInfo"
            label="错误信息"
            header-align="center"
            align="center"
            fixed="right"
            width="150"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.errorInfo | errorInfo }}
            </template>
          </el-table-column>
          <el-table-column label="操作" header-align="center" align="center" fixed="right" width="150">
            <template slot-scope="scope">
              <a class="txt-color" @click="save(scope.row)">保存 | </a>
              <a class="txt-color-red" @click="deletes(scope.row.guid)">删除</a>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pt pb back-color-fff"
          style="padding: 16px"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 100, 200]"
          :current-page="page.pageIndex"
          :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.totalRows"
        >
        </el-pagination>
        <div class="mt15 t-right">
          <el-button size="medium" plain @click="active = 0">取消</el-button>
          <el-button size="medium" type="info" @click="nextImport()" v-loading.fullscreen.lock="fullscreenLoading"
            >导入</el-button
          >
        </div>
      </div>

      <div class="font-S16 mt50 h150" v-if="active == 2">
        <img width="64" height="64" src="../../assets/images/right.png" /><br /><br />
        导入成功，本次共导入<b class="fontC-4fa1a4">{{ importSum }}</b
        >条数据
      </div>
    </div>
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
import areaJson from '../../assets/js/china_address_v4.js';
export default {
  data() {
    return {
      url: `/${serverConfig.msSalesPerformService}/import-data/staff-salary-real`,
      active: 0,
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        importType: '0007',
        errorFlag: '',
      },
      importSum: 0,
      loading: true,
      tableData: [],
      provinceList: areaJson,
      cityList: [],
      districtList: [],
      guids: [],
      errorRows: 0,
      totalRows: 0,
      fullscreenLoading: false,
      doctorTypeOption: [],
      checkedList: [],
      unitGuid: '',
      accountMonth: '',
      bizUnitNameOptions: [],
      sendTenantGuid:"",
      sendTenantList:[],
      billCycle: null, //周期
      billCycleOption: ['一期', '二期', '三期', '四期', '五期', '六期', '七期', '八期', '九期', '十期', '十一期', '十二期', '十三期', '十四期', '十五期', '十六期', '十七期', '十八期', '十九期', '二十期', '二十一期', '二十二期', '二十三期', '二十四期', '二十五期', '二十六期', '二十七期', '二十八期', '二十九期', '三十期'],
      cycleDate: null,//周期范围起止
    };
  },
  created() {
    this.getDoctorType();
    this.getbizUnitNameOptions();
    this.getSendTenantList();
  },
  methods: {
    getSendTenantList() {
      let self = this;
      let query = {
        isService: true,
        tenantGuid: localStorage.guid,
      };
      self.api
        .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.sendTenantList = res.data.data;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getbizUnitNameOptions() {
      let self = this;
      let page = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: self.$store.getters.getTenantGuid,
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-unit/data/get-biz-unit`, page).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          var list = res.data.data.records;
          self.bizUnitNameOptions = list;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handelUpload() {},
    //获取医师职称下拉字典
    getDoctorType() {
      let that = this;
      that.api
        .get(
          `/${serverConfig.msConfigureService}/sysparameter/data/get-detail-grp?tenantGuid=${this.$store.state.guid}&code=YSZC_HYS`,
        )
        .then((resp) => {
          if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let data = resp.data.data;
            let arr = [];
            data.forEach((item) => {
              let obj = {
                label: item.name,
                value: item.parameterValue,
              };
              arr.push(obj);
            });
            that.doctorTypeOption = arr;
          }
        });
    },
    toLink(link) {
      this.$router.push({ path: link,  productGuid: this.$route.query.productGuid });
    },
    province(pr) {
      let self = this;
      self.cityList = [];
      self.provinceList.forEach(function (i) {
        if (i.label == pr) {
          if (i.children != null && i.children != '') {
            i.children.forEach(function (j) {
              self.cityList.push(j);
            });
          }
        }
      });
    },
    city(ci) {
      let self = this;
      console.log(self.cityList);
      self.districtList = [];
      self.cityList.forEach(function (i) {
        if (i.label == ci) {
          if (i.children != null && i.children != '') {
            i.children.forEach(function (j) {
              self.districtList.push(j);
            });
          }
        }
      });
    },
    uploadExcel() {
      window.open('/底薪考核管理导入模板.xlsx');
    },
    beforeUpload(file) {
      let filename = file.name;
      let arr = filename.split('.');
      if (arr[1] !== 'xls' && arr[1] !== 'xlsx'&& arr[1] !== 'xlsm') {
        this.$message.error('上传文件只能是 excel/xls 格式!');
        return false;
      }
      return arr;
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`,
      );
    },
    changeFile(file, fileList) {
      let self = this;
      let isLt5M = file.size / 1024 / 1024 < 5;
      if (this.accountMonth == '') {
        self.$message.error('请选择账单月份');
        self.$refs.upload.clearFiles(); // 清除前端显示的文件列表
        return;
      }
      if (this.unitGuid == '') {
        self.$message.error('请选择核算单元');
        self.$refs.upload.clearFiles(); // 清除前端显示的文件列表
        return;
      }
      if (!this.billCycle && this.cycleDate) {
        this.$message.error('请选择账单周期!')
        self.$refs.upload.clearFiles(); // 清除前端显示的文件列表
        return
      }
      if (this.billCycle && !this.cycleDate) {
        this.$message.error('请选择周期范围!')
        self.$refs.upload.clearFiles(); // 清除前端显示的文件列表
        return
      }
      
      if (!isLt5M) {
        self.$message.error('上传文件大小不能超过 5MB');
        file = null;
        fileList = [];
        self.$refs.upload.clearFiles(); // 清除前端显示的文件列表
      } else {
        self.fullscreenLoading = true;
        let formData = new FormData();
        let unitName ="";
        formData.append('file', file.raw); //传文件
        this.bizUnitNameOptions.forEach(item=>{
          if(item.guid ==  this.unitGuid ){
            unitName = item.label;
          }
        })
        let url =
          self.url +
          '?progressGuid=' +
          self.generateUUID() +
          '&accountMonth=' +
          self.accountMonth.replace('-', '') +
          '&tenantGuid=' +
          localStorage.guid +
          '&unitGuid=' +
          this.unitGuid +
          '&unitName=' +
          unitName;
        if (this.billCycle) {
          url = url + '&billCycle=' + this.billCycle;
        }
        if (this.cycleDate && this.cycleDate.length) {
          url = url + '&cycleStartDate=' + this.cycleDate[0] + '&cycleEndDate=' + this.cycleDate[1]
        }
        self.api.postFile(url, formData).then(function (res) {
          self.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message({
              type: 'success',
              message: '上传成功',
            });
          } else {
            self.$message({
              type: 'error',
              message: res.data.msg,
            });
            self.$refs.upload.clearFiles(); // 清除前端显示的文件列表
            return false;
          }
        });
      }
    },
    generateUUID() {
      var d = new Date().getTime();
      if (window.performance && typeof window.performance.now === 'function') {
        d += performance.now(); //use high-precision timer if available
      }
      var uuid = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
      });
      return uuid;
    },
    next() {
      let self = this;
      self.active = 1;
      self.getData(true);
    },
    getDataAll() {
      let self = this;
      self.page.errorFlag = '';
      self.getData(true);
    },
    getDataErrorFlagY() {
      let self = this;
      self.page.errorFlag = 'Y';
      self.getData(true);
    },
    getDataErrorFlagN() {
      let self = this;
      self.page.errorFlag = 'N';
      self.getData(true);
    },
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      self.tableData = [];
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/import-data/get-import-intermediate-data`, self.page)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tableData = res.data.data.details.records;
            self.errorRows = res.data.data.errorRows;
            self.totalRows = res.data.data.totalRows;
            self.page.totalPage = res.data.data.details.totalPages;
            self.page.totalRows = res.data.data.details.totalRows;
            self.loading = false;
          } else {
            self.$message.error(res.data.msg);
            self.loading = false;
          }
        });
    },
    save(row) {
      let self = this;
      row.errorFlag = 'N';
      row.errorInfo = '';
      self.loading = true;
      self.api.put(`/${serverConfig.msSalesPerformService}/import-data/update-intermediate-data`, row).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success('保存成功');
          self.getData(true);
        } else {
          self.$message.error(res.data.msg);
          self.loading = false;
        }
      });
    },
    deletes(guid) {
      let self = this;
      self.guids = [];
      self.guids.push(guid);
      self.loading = true;
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/import-data/delete-intermediate-data`, self.guids)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success('删除成功');
            self.getData(true);
          } else {
            self.$message.error(res.data.msg);
            self.loading = false;
          }
        });
    },
    // 多选删除
    handleSelectionChange(val) {
      console.log('多选删除', val);
      let arr = [];
      val.forEach((item) => {
        arr.push(item.guid);
      });
      this.checkedList = arr;
    },
    pitchDelet() {
      if (this.checkedList.length) {
        let self = this;
        self.loading = true;
        self.api
          .postJson(`/${serverConfig.msSalesPerformService}/import-data/delete-intermediate-data`, self.checkedList)
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('删除成功');
              self.getData(true);
            } else {
              self.$message.error(res.data.msg);
              self.loading = false;
            }
          });
      } else {
        this.$message.error('请勾选需要删除的数据！');
      }
    },
    nextImport() {
      let self = this;
      self.fullscreenLoading = true;
      self.api
        .postJson(
          `/${serverConfig.msSalesPerformService}/import-data/finish-staff-salary-real?tenantGuid=` +
            self.$store.state.guid +
            '&progressGuid=' +
            this.generateUUID(),
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.importSum = res.data.data;
            self.$message.success('导入成功');
            self.active = 2;
            self.fullscreenLoading = false;
          } else {
            self.active = 1;
            self.getData(true);
            self.$message.error(res.data.msg);
            self.fullscreenLoading = false;
          }
        });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      self.getData(false);
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      self.getData(false);
    },
  },
};
</script>
<style  scoped>
.search-area-div{
  width:90px;
  word-break: keep-all;
  display: flex;
  align-items: center;

}
.importList /deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}
.importList /deep/ .el-step__icon-inner {
  color: #4fa1a4;
}
.importList /deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
.input-item {
  margin: 20px 20px 0 0;
  display: flex;
}
.input-item .search-area-div {
  text-align: left;
  width: 90px;
}
.import-wrap /deep/ .el-button {
  margin-left: 12px;
}
.select-box-item{
  margin-top: 50px;
  display: flex;
}
.importList .select-list{
  display: flex;
  margin-right: 30px;
}
.importList .select-list label{
  width: 88px;
  flex-shrink: 0;
  line-height: 36px;
  text-align: right;
  /* width: ; */
}
.importList .select-list label span{
  color: red;
}
</style>